import React, { useMemo } from 'react';
import type { NativeSelectOption, NativeSelectProps } from '@eva-pacs/ui';
import { NativeSelect } from '@eva-pacs/ui';

import { useGetAssignablePractitionerOptions } from '~/src/hooks/practitioners/useGetAssignablePractitionerOptions';
import { useTranslation } from 'react-i18next';

interface PractitionerCellProps extends Omit<NativeSelectProps, 'options'> {
  fallbackOption: NativeSelectOption;
}
/**
 * Practitioner Cell (Table)
 * @author Alejandro Forero<alejandro.forero@edenmed.com>
 * Created at 2024-01-31
 */

export const PractitionerCell = ({ fallbackOption, isDisabled, ...restOfProps }: PractitionerCellProps) => {
  const { t } = useTranslation();
  const { options, loading } = useGetAssignablePractitionerOptions({
    fetchPolicy: 'cache-first',
  });

  const UNASSIGNED_PRACTITIONER = {
    label: t('admin.permission.practitioners.options.unassigned'),
    value: '',
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const fullPractitionerOptions: Array<NativeSelectOption> = useMemo(() => [UNASSIGNED_PRACTITIONER, ...options], [
    options,
    t,
  ]);

  return (
    <NativeSelect
      options={options.length > 0 ? fullPractitionerOptions : [UNASSIGNED_PRACTITIONER, fallbackOption]}
      isDisabled={isDisabled || loading}
      {...restOfProps}
    />
  );
};
